<template>
    <div id="detail">
        <main class="container-wrap">
            <section class="detail-wrap">
                <div class="detail-main">
                    <div class="detail-top">
                        <figure class="detail-screen">
                            <span>
                                <img class="lazyLoad isLoaded" :src=getBanner()>
                            </span>
                        </figure>
                        <hgroup>
                            <h1>
                                {{$tt(detail.pd_num) }}
                            </h1>
                            <a :href="getUrlLink()" target="_blank">LIVE DEMO</a>
                            <p>
                                <span><strong>{{ $tt('支持语言')}} :</strong></span> <br> 
                                <span>{{ $tt(detail.supported_lang) }}</span> <br> 
                                <span><strong>{{ $tt('测试域名') }}:</strong></span> <br>
                                <span><strong>{{ $tt('电脑端') }}:</strong> <a class="detail-link" :href="detail.pc_url" target="_blank">{{ detail.pc_url }}</a></span><br>
                                <span><strong>{{ $tt('手机端') }}:</strong> <a class="detail-link" :href="detail.mobile_url" target="_blank">{{ detail.mobile_url }}</a></span><br>
                                <span><strong>{{ $tt('测试账号') }}:</strong> {{ detail.user }}</span><br>
                                <span><strong>{{ $tt('说明') }}:</strong> {{ $tt(detail.description) }} {{ $tt(detail.description2) }} {{ $tt(detail.description3) }}</span>
                            </p>
                        </hgroup>
                        <div>
                            <button class="is-prev" @click="previousTemplate()"></button> 
                            <button class="is-next" @click="nextTemplate()"></button>
                        </div>
                    </div>
                    <Slick class="detail-slider" ref="slickSettings" :options="slickSettings" >
                        <div v-for="(template,index) in templateData" :key="index">
                            <img :src="templateData[index]">
                        </div>
                    </Slick>
                   
                </div>
                <div></div>
                <div class="close-wrapper">
                    <button @click="handleClose()"></button>
                </div>
                
            </section>
        </main>
    </div>
</template>


<script type="application/javascript">
import Slick from 'vue-slick';
import jquery from '../js/jquery.min.js'
import config from '../config';
import 'slick-carousel/slick/slick.css';

export default {
    data() {
        return {
            detail: {},
            pd_id: "",
            slickSettings: {},
            templateData: [],
            isH5: false
        }
    },
    created() {
        this.pd_id = this.$route.params.id
        this.detail = Object.assign(config.data.find(item => item.pd_id == this.pd_id))
        this.templateData = [...this.detail.pd_template_img]
        this.slickSettings = {
            accessibility: false,
            dots: true,
            slidesToShow: 1,
            swipe: true,
            swipeToSlide: true,
            adaptiveHeight: true,
            touchMove: false,
            swipe: false,
        };
       
    },
    components: {
        Slick,
    },
    mounted () {
        this.detail = Object.assign(config.data.find(item => item.pd_id == this.pd_id))
        this.templateData = [...this.detail.pd_template_img]
        setTimeout(() => {
            $(".detail-slider").not(".slick-initialized").slick(
                {
                    accessibility: false,
                    dots: true,
                    slidesToShow: 4,
                    slidesPerRow: 1,
                    swipe: true,
                    swipeToSlide: true,
                    adaptiveHeight: true,
                    touchMove: false,
                    swipe: false,
                }
            );
        }, 200);
        this.isH5 = /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)
        $(".header-wrap").hide();      
        var e = .01 * window.innerHeight;
        document.documentElement.style.setProperty("--vh", "".concat(e, "px")),
                    $(window).resize((function() {
                        $(".nav-menu-btn").removeClass("is-active"),
                        $(".nav-wrap").removeClass("is-active"),
                        $(".nav-filter-btn").removeClass("is-active"),
                        $(".index-filter-wrap").removeClass("is-active"),
                        $(".overlay").removeClass("is-active"),
                        $(".index-filter-sub").css("display", ""),
                        $(".index-filter-btn").removeClass("is-active")
                    }
                    )) 
    },
    methods: {
        getUrlLink(){
            return this.isH5 ? this.detail.mobile_url : this.detail.pc_url;
        },
        handleClose() {
            $(".header-wrap").show();
            this.$router.push("/")
        },
        next() {
            this.$refs.slickSettings.next();
        },

        prev() {
            this.$refs.slickSettings.prev();
        },
        reInit() {
           
            this.$nextTick(() => {
                this.$refs.slickSettings.reSlick();
            });
        },
        getBanner(){ 
            return this.detail.pd_view_img;
        },
        previousTemplate(){
            if (this.pd_id == 1){
                this.pd_id = config.data.length
                this.detail = Object.assign(config.data.find(item => item.pd_id == this.pd_id))
                this.templateData = [...this.detail.pd_template_img]
                this.$router.push(`/detail/${this.pd_id}`)
            }else {
                this.pd_id = this.pd_id - 1;
                this.detail = Object.assign(config.data.find(item => item.pd_id == this.pd_id))
                this.templateData = [...this.detail.pd_template_img]
                this.$router.push(`/detail/${this.pd_id}`)
            }
            
        },
        nextTemplate(){
            if (this.pd_id < config.data.length){
                this.pd_id = parseInt(this.pd_id) + 1;
                this.detail = Object.assign(config.data.find(item => item.pd_id == this.pd_id))
                this.templateData = [...this.detail.pd_template_img]
                this.$router.push(`/detail/${this.pd_id}`)
            }else {
                this.pd_id = 1;
                this.detail = Object.assign(config.data.find(item => item.pd_id == this.pd_id))
                this.templateData = [...this.detail.pd_template_img]
                this.$router.push(`/detail/${this.pd_id}`)
            }
        }   
    }
}
</script>

<style>

.detail-link{
    border: none !important;
    margin: 0px !important;
    line-height: 18px !important;
    font-style: normal !important;
    text-align: start !important;
    max-width: 280px !important;
}
.detail-wrap {
    position: relative;
    min-height: 100vh;    
    background-color: #f9f9f9;
    padding-top: 100px;
    padding-bottom: 40px;
}

.close-wrapper {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 10;
    display: block;
    width: 80px;
    height: 80px;
}
.close-wrapper> button {
    background-color: transparent;
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAiCAYAAACnSgJKAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAABZ0RVh0Q3JlYXRpb24gVGltZQAwNC8yNS8yMJW6AqMAAAAcdEVYdFNvZnR3YXJlAEFkb2JlIEZpcmV3b3JrcyBDUzbovLKMAAABwUlEQVRYhcWYvXHCMACFP2sBGCEbQOcSV2pDJsBswChmgpgJQkqrgg53eANGSCZQCss5Y/wjySZ5dxyc/r4n+1mWQGuN1posu8yr38/81DlBll2WQAosKPUJxFKGX0wkpfK5YbyaogKIBZDUwJgGp6nARqcaGMNLBLBqabxQKk+noJpxFi1VK9HTbzPWgOm/6aoXwPkZBobAwFkAa8oATGbAAlwA60BrjVL5C3AFZj0dDlKG8QTgb2ApZXgTAFKGNyAyFV0avAKW4Mjw+A2clOF1jAEH8LUquEu7g4GkAU5cwQCB1vqhpVL5knJh6MvAVsowVSqPgXdXcCfcwcABjxkPwh0MeIGhcc+bssyAF3gQXjMQO8LjIbAV3Bg4AltL8Na0H5QV/FnqDVwlpfI18OEw7pvN7AfhnokfH7gRj9oMOJn+7nCHRcbbQCvcYXmN6X8Keg08wC3BeynDFMB8730M3AXO9lK3bSpGvVLHgAFMuVMG/nUbFWTZZU4547a9tRPYwUABRAI4TgkGq1uwAI5dJxZvsIOB3hOLN9jWQNeJpRgLbhhoO5ScBbBrVH5S7l6mVGTGrVQAu9ZD+1/9OfADiQi5wLUBOoEAAAAASUVORK5CYII=);
    background-repeat: no-repeat;
    background-position: 50% 50%;
    border: 0;
    width: 80px;
    height: 80px;
}



.detail-wrap:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    width: calc(50% - 10px);
    height: 100%;
    background-image: url("../images/inside_bg.f44a7b5.jpg");
    background-repeat: repeat;
    background-position: 0 0;
}
.detail-main {
    position: relative;
    z-index: 1;
    max-width: 1000px;
    margin: 0 auto;
}

.detail-top {
    position: relative;
    margin-bottom: 42px;
}
.detail-top:after, .detail-top:before {
    content: " ";
    display: table;
}

.detail-slider {
    background-color: #263239;
    padding-top: 70px;
}

.slick-prev {
    top: 0;
    width: 70px;
    height: 70px;
    left: '0';
    background-position: 50% 50%;
    background-repeat: no-repeat;
    background-size: 100% auto;
    position: absolute;
    z-index: 20;
    display: block;
    font-size: 0;
    color: transparent;
    padding: 0;
    cursor: pointer;
    border: none;
    outline: none;
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAABGCAYAAABxLuKEAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAABx0RVh0U29mdHdhcmUAQWRvYmUgRmlyZXdvcmtzIENTNui8sowAAAAWdEVYdENyZWF0aW9uIFRpbWUAMDQvMjgvMjBn0Np+AAAB2ElEQVR4nO3asU4CQRRG4YPaYWdlYWspQicJlCbIQxg7H4DG2NgYGl8HSXgIUVugZqmBWhu1UK6gcWb+ifd0my3m5ks22dxM6bB28oL3pa3UA6jmMEYOY+QwRg5j5DBGDmPkMEYOY+QwRg5j5DBGDmPkMEYOY7STeoBNqlWqVI+OAbgf9JnOiuBnltQXVe3TFtedq4/nxXLJ+eVFcBzpT+kzCsBuuczZaSv42bIwq1BiJgmzDmX4/Bh8BjmYdSi3d10enobB55CC2QSlN+hHmUUGRgkFRGDUUEAARhEFEsOookBCGGUUSASjjgIJYHJAgcgwuaBARJicUCASTG4oEAGmVqlmhwIRYN43b6tSRQGBP1/VgsN8tzu57lzRjrCN+03be/sHNyEPmM4KillBs95Y+b5Zb1DMCkaTccgxflxwGIDRZJwdThQYyA8nGgzkhRMVBvLBiQ4DeeAkgQF9nGQwoI2TFAZ0cZLDgCaOBAzo4cjAgBaOFAxshjN8fvyf92N6gz63d13z/Xc7nr9KEgbW44ROFgZW4yyWS+4jbP3kLyf23i4jNusN5ou5X05MnfSnlDKHMXIYI4cxchgjhzFyGCOHMXIYI4cxchgjhzFyGCOHMXIYo1ewIToPE6j6zQAAAABJRU5ErkJggg==);
}

.slick-next {
    top: 0;
    width: 70px;
    height: 70px;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    background-size: 100% auto;
    position: absolute;
    z-index: 20;
    display: block;
    font-size: 0;
    color: transparent;
    padding: 0;
    cursor: pointer;
    border: none;
    outline: none;
    right: 0;
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAABGCAYAAABxLuKEAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAABx0RVh0U29mdHdhcmUAQWRvYmUgRmlyZXdvcmtzIENTNui8sowAAAAWdEVYdENyZWF0aW9uIFRpbWUAMDQvMjgvMjBn0Np+AAABzElEQVR4nO3bsUoDQRRG4ROx3F7rmFiK2vkABmPeJEWqSCBYpAoEUqXIO4hgKYIPoVgvaYP9WmsnirkkAXPnH7in291ihg8yuztka8fnF59Ef9pLPQHVAsYoYIwCxihgjALGKGCMAsYoYIwCxihgjALGKGCMAsYoYIz2PQfrtNocHhxSfVTcPdx7Dr11bjC3N0OuL6++jzutNt1+j6qqvKawVW4/pZ8oAI16g/l0RlEUXlPYqqRrjDKOG8zL2+vK86o4bjCD0ZByUa68pojjBlNVFd1+Lxsc1zUmJxz3xTcXnCR3pRxwkt2u1XGSPsco4yR/iVTFSQ4DmjgSMKCHIwMDWjhSMKCDIwcDm+FMRuOdzkESBtbjnJ2c7nR8WZjUycIURcF8OqNRb6y8bu3v/FeSMOtQykXJYDTc6RzkYDZB8dhEl4JRQQEhGCUUEIFRQwEBGEUUSAyjigIJYZRRIBGMOgokgMkBBZxhckEBR5icUMARZjIaZ4MCjjDW/okiCiR+jlFFAUeYx+enX8fKKAA1z49FO602zaMmy/el/J8TXWFyKvlLpGoBYxQwRgFjFDBGAWMUMEYBYxQwRgFjFDBGAWMUMEYBYxQwRl+iDymRKDI5qgAAAABJRU5ErkJggg==);
}

.slick-list {
    position: relative;
    display: block;
    overflow: hidden;
    margin: 0;
    padding: 0;
    transform: translateZ(0);
}

.slick-track {
    transform: translateZ(0);
}

.slick-dots {
    top: 30px;
    left: 0;
    position: absolute;
    z-index: 1;
    display: block;
    width: 100%;
    padding: 0;
    margin: 0;
    list-style: none;
    text-align: center;
    
}
.slick-dots > li {
     
        position: relative;
        display: inline-block;
        vertical-align: top;
        width: auto;
        height: auto;
        margin: 0 3px;
        padding: 0;
        cursor: pointer;
}

.slick-dots li button {
    line-height: 0;
    display: block;
    width: 10px;
    height: 10px;
    font-size: 0;
    color: transparent;
    background-color: #fff;
    border-radius: 100%;
    border: 0;
    outline: none;
    padding: 0;
    opacity: .5;
    cursor: pointer;
}

.slick-dots li.slick-active button {
    opacity: 1;
}

.detail-wrap>button {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 10;
    display: block;
    width: 80px;
    height: 80px;
    background-color: transparent;
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAiCAYAAACnSgJKAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAABZ0RVh0Q3JlYXRpb24gVGltZQAwNC8yNS8yMJW6AqMAAAAcdEVYdFNvZnR3YXJlAEFkb2JlIEZpcmV3b3JrcyBDUzbovLKMAAABwUlEQVRYhcWYvXHCMACFP2sBGCEbQOcSV2pDJsBswChmgpgJQkqrgg53eANGSCZQCss5Y/wjySZ5dxyc/r4n+1mWQGuN1posu8yr38/81DlBll2WQAosKPUJxFKGX0wkpfK5YbyaogKIBZDUwJgGp6nARqcaGMNLBLBqabxQKk+noJpxFi1VK9HTbzPWgOm/6aoXwPkZBobAwFkAa8oATGbAAlwA60BrjVL5C3AFZj0dDlKG8QTgb2ApZXgTAFKGNyAyFV0avAKW4Mjw+A2clOF1jAEH8LUquEu7g4GkAU5cwQCB1vqhpVL5knJh6MvAVsowVSqPgXdXcCfcwcABjxkPwh0MeIGhcc+bssyAF3gQXjMQO8LjIbAV3Bg4AltL8Na0H5QV/FnqDVwlpfI18OEw7pvN7AfhnokfH7gRj9oMOJn+7nCHRcbbQCvcYXmN6X8Keg08wC3BeynDFMB8730M3AXO9lK3bSpGvVLHgAFMuVMG/nUbFWTZZU4547a9tRPYwUABRAI4TgkGq1uwAI5dJxZvsIOB3hOLN9jWQNeJpRgLbhhoO5ScBbBrVH5S7l6mVGTGrVQAu9ZD+1/9OfADiQi5wLUBOoEAAAAASUVORK5CYII=);
    background-repeat: no-repeat;
    background-position: 50% 50%;
    border: 0;
}
.detail-top>div {
    position: absolute;
    top: 206px;
    right: 0;
    z-index: 1;
    display: block;
    width: 70px;
}
.detail-top>hgroup {
    width: calc(100% - 660px);
    padding: 0px 16px 0 44px;
    float: left;
}


@media only screen and (max-width: 768px) {
    #detail {
        margin-top: -80px;
    }
    .detail-wrap {
        padding-top: 0;
    }
    .detail-wrap > button {
        width: 70px;
        height: 70px;
    }
    .detail-wrap::before {
        width: 50%;
    }
    .detail-top {
        margin-bottom: 26px;
        padding: 0 80px 0 140px;
    }
    .detail-top>div {
        top: 0;
        left: 0;
        width: 140px;
    }
    .detail-top>hgroup {
        width: 100%;
        text-align: center;
        padding: 0;
        /* width: 100%;
        text-align: center;
        padding: 0;
        display: flex;
        justify-content: center;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap; */
    }
    .detail-top>hgroup>h1 {
       
       font-size: 1.5rem;
    }
    .detail-wrap>button {
        width: 70px;
         height: 70px;
    }
}


@media only screen and (max-width: 1024px) {
    .detail-wrap {
        padding-bottom: 0;
    }
    .detail-top {
        padding: 0 32px;
    }
}

@media only screen and (max-width: 480px) {
    .detail-top {
        padding: 0 14.5vw 0 29vw;
        margin-bottom: 5vw;
    }
    .detail-top>hgroup h1 {
        line-height: 14.5vw;
        font-size: 8vw;
    } 
    .detail-top>div button {
        width: 12.5vw;
        height: 12.5vw;
    }

    .close-wrapper {
        width: 12.5vw;
        height: 12.5vw;
        position: absolute;
    }
    .close-wrapper> button {
        background-color: transparent;
        background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAiCAYAAACnSgJKAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAABZ0RVh0Q3JlYXRpb24gVGltZQAwNC8yNS8yMJW6AqMAAAAcdEVYdFNvZnR3YXJlAEFkb2JlIEZpcmV3b3JrcyBDUzbovLKMAAABwUlEQVRYhcWYvXHCMACFP2sBGCEbQOcSV2pDJsBswChmgpgJQkqrgg53eANGSCZQCss5Y/wjySZ5dxyc/r4n+1mWQGuN1posu8yr38/81DlBll2WQAosKPUJxFKGX0wkpfK5YbyaogKIBZDUwJgGp6nARqcaGMNLBLBqabxQKk+noJpxFi1VK9HTbzPWgOm/6aoXwPkZBobAwFkAa8oATGbAAlwA60BrjVL5C3AFZj0dDlKG8QTgb2ApZXgTAFKGNyAyFV0avAKW4Mjw+A2clOF1jAEH8LUquEu7g4GkAU5cwQCB1vqhpVL5knJh6MvAVsowVSqPgXdXcCfcwcABjxkPwh0MeIGhcc+bssyAF3gQXjMQO8LjIbAV3Bg4AltL8Na0H5QV/FnqDVwlpfI18OEw7pvN7AfhnokfH7gRj9oMOJn+7nCHRcbbQCvcYXmN6X8Keg08wC3BeynDFMB8730M3AXO9lK3bSpGvVLHgAFMuVMG/nUbFWTZZU4547a9tRPYwUABRAI4TgkGq1uwAI5dJxZvsIOB3hOLN9jWQNeJpRgLbhhoO5ScBbBrVH5S7l6mVGTGrVQAu9ZD+1/9OfADiQi5wLUBOoEAAAAASUVORK5CYII=);
        background-repeat: no-repeat;
        background-position: 50% 50%;
        border: 0;
        width: 12.5vw;
        height: 12.5vw;
    }

   
}
</style>